import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CambiaClave, AutenticaCli } from '@laranda/lib-ucontrol';


@Component({
  selector: 'app-cambia-clave',
  templateUrl: './cambia-clave.component.html',
  styleUrls: ['./cambia-clave.component.scss']
})
export class CambiaClaveComponent implements OnInit {

  verPass: string;
  formClave: FormGroup;

  constructor(
    private fb: FormBuilder,
    private cambiaClave: CambiaClave,
    public autenticaCli: AutenticaCli
  ) {
    this.formClave = this.fb.group({
      pwdOld: ['', [Validators.required, Validators.minLength(4)]],
      pwdNew: ['', [Validators.required, Validators.minLength(4)]],
      pwdNew2: ['', [Validators.required, Validators.minLength(4)]]
    });
  }

  ngOnInit(): void {
    this.verPass = 'password';
    this.autenticaCli.leerToken();
  }

  claveVisible() {
    this.verPass = 'text';
  }
  claveOculta() {
    this.verPass = 'password';
  }

  menuVisible(): boolean {
    return (this.autenticaCli.CadOut !== null) && (this.autenticaCli.CadOut.Entradaini[0] === 'N');
  }

  onCambiarCl() {

    Object.values( this.formClave.controls ).forEach( control => {
      if ( control.invalid ) {
        control.markAllAsTouched();
      }
    });

    if (this.formClave.valid) {
      this.cambiaClave.ParamIn.email = this.autenticaCli.CadOut.Email;
      this.cambiaClave.ParamIn.pwdant = this.formClave.value.pwdOld;
      this.cambiaClave.ParamIn.pwdnew = this.formClave.value.pwdNew;
      this.cambiaClave.consultar();
    }
  }

  get correoNoValido() {
    return (this.formClave.get('correo').invalid && this.formClave.get('correo').touched);
  }

  get PasswordNoValido() {
    return (this.formClave.get('pwdOld').invalid && this.formClave.get('pwdOld').touched);
  }

  get PasswordNewNoValido() {
    return (this.formClave.get('pwdNew').invalid && this.formClave.get('pwdNew').touched);
  }

  get PasswordNew2NoValido() {
    return (this.formClave.get('pwdNew2').invalid && this.formClave.get('pwdNew2').touched);
  }

  get PasswordIgual() {
    return (this.formClave.get('pwdNew').value !== this.formClave.get('pwdNew2').value);
  }
}
